// Idiomas de la interfaz: los mismos que sirve la API (es, en, fr).
export const LOCALES = ['es', 'en', 'fr'] as const
export type Locale = (typeof LOCALES)[number]

export const isLocale = (value: unknown): value is Locale =>
	typeof value === 'string' && (LOCALES as readonly string[]).includes(value)

// Idioma inicial: el elegido antes en este dispositivo → el primero soportado del navegador
// → español.
export const detectLocale = (stored: unknown, browserLanguages: readonly string[]): Locale => {
	if (isLocale(stored)) return stored
	for (const language of browserLanguages) {
		const primary = language.split('-')[0]?.toLowerCase()
		if (isLocale(primary)) return primary
	}
	return 'es'
}

// Fechas en el idioma de la interfaz (p. ej. "13 de octubre de 2026").
export const formatDate = (iso: string, locale: Locale): string =>
	new Intl.DateTimeFormat(locale, {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
		timeZone: 'Europe/Madrid',
	}).format(new Date(iso))

// Distancias en km con el separador decimal del idioma (12,5 / 12.5), sin decimales de sobra.
export const formatKm = (km: number, locale: Locale): string =>
	new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(km)
